import React from "react"
import DesignTokens from "../designTokens"

const User = ({ color }) => {
  const iconColor = color || DesignTokens.colors.white
  return (
    <svg
      height="24"
      viewBox="0 0 22 24"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="a" fill="#fff">
        <path
          d="m.94176923.30123077h6.88176923v8.16030769h-6.88176923z"
          fill="#fff"
        />
      </mask>
      <mask id="b" fill="#fff">
        <path
          d="m0 22.9470154h21.362v-22.94769232h-21.362z"
          fill="#fff"
        />
      </mask>
      <g fill={iconColor}>
        <path d="m10.6735538 1.69230769c-1.37584611 0-2.3641538.35030769-3.01907688 1.07123077-.84276923.93076923-1.16261538 2.51984616-.9476923 4.72661539.32661538 3.36599995 1.88523076 5.54061535 3.96676918 5.54061535 2.0392308 0 3.5961539-2.1796923 3.9684616-5.55246151.2403077-2.178-.0626154-3.75692307-.902-4.69276923-.6481539-.726-1.6804616-1.09323077-3.0664616-1.09323077m0 13.03076921c-3.01569226 0-5.23430765-2.7753846-5.65061534-7.07046152-.264-2.70092307.20138462-4.72661538 1.37923077-6.02630769.97984615-1.078 2.41661539-1.62630769 4.27138457-1.62630769 1.8869231 0 3.344.55846154 4.3289231 1.65676923 1.1710769 1.30815385 1.6161539 3.33046154 1.3216923 6.00769231-.4721538 4.28661536-2.6907692 7.05861536-5.6506154 7.05861536" />
        <path d="m1.69230769 22.9470154h-1.69230769l.01692308-4.18c.13030769-.6464616.75984615-1.8852308 2.288-2.4403077 1.4756923-.5347692 3.93461538-1.5383077 3.938-1.54l.6396923 1.5670769s-2.50123076 1.0221539-4.00061538 1.5653846c-.84446154.3046154-1.11861538.9273846-1.18969231 1.1321539z" />
        <path
          d="m7.82438462 8.46153846h-1.6923077v-3.89907692c-.066-.19123077-.33846154-.82076923-1.1896923-1.12876923-1.49938462-.54323077-4.00061539-1.56538462-4.00061539-1.56538462l.63969231-1.56707692c.00338461.00169231 2.46230769 1.00523077 3.938 1.54 1.52646154.55507692 2.156 1.79384615 2.288 2.43861538l.01692308.16923077z"
          mask="url(#a)"
          transform="translate(13.538462 14.485477)"
        />
        <path
          d="m9.84923077 22.0365538h1.69230773v-3.1358461h-1.69230773z"
          mask="url(#b)"
        />
      </g>
    </svg>
  )
}

export default User
